<template>
  <div>
    <sms-log v-if="allMessages" @switch="allMessages = $event" />
    <sms-conversations v-else :new-message-signal="newMessageSignal" @switch="allMessages = $event" />
  </div>
</template>

<script setup lang="ts">
// SMS tab of the Messages page: conversations by default; the Every message filter
// toggle swaps in the per-message log, and switching it off comes back here.
import { ref, watch } from 'vue'
import SmsConversations from './SMSConversations.vue'
import SmsLog from './SMSLog.vue'

const props = withDefaults(defineProps<{ newMessageSignal?: number }>(), { newMessageSignal: 0 })
const allMessages = ref(false)

// New message always lives on the conversations view
watch(() => props.newMessageSignal, () => { allMessages.value = false })
</script>
